import type { Template } from "@/types";

export const LA_04_H1_V3: Template[] = [
    {
        id: "la-04-h1v3-01",
        name: "LA 01 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 172, y: 0, width: 333, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 871, y: 48, width: 286, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 233, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 233, width: 139, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-02",
        name: "LA 02 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 48, width: 271, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 385, y: 48, width: 186, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 385, y: 171, width: 186, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 877, y: 48, width: 274, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-03",
        name: "LA 03 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 204, y: 48, width: 267, height: 387, rotation: 0, imageRotation: 0 },
            { id: "2", x: 871, y: 48, width: 286, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 233, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 233, width: 139, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-04",
        name: "LA 04 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_04.png",
        size: [1352, 483],
        style: {},
        slots: [  
            { id: "1", x: 46, y: 105, width: 190, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 105, width: 189, height: 273, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 105, width: 189, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 722, y: 48, width: 584, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-05",
        name: "LA 05 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 119, y: 105, width: 440, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 795, y: 38, width: 288, height: 408, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1090, y: 37, width: 143, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 245, width: 143, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-06",
        name: "LA 06 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 194, y: 254, width: 288, height: 180, rotation: 0, imageRotation: 0 }, 
            { id: "2", x: 194, y: 49, width: 140, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 49, width: 140, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 879, y: 49, width: 271, height: 384, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-07",
        name: "LA 07 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 139, y: 55, width: 261, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 55, width: 130, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 245, width: 130, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 55, width: 589, height: 373, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-08",
        name: "LA 08 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 55, width: 589, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 55, width: 261, height: 373, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1083, y: 55, width: 130, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1083, y: 245, width: 130, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-09",
        name: "LA 09 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_09.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 43, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 531, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 70, width: 533, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-10",
        name: "LA 10 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h1_v3_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 70, width: 533, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 828, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1072, y: 70, width: 236, height: 343, rotation: 0, imageRotation: 0 }
        ],
    }
];

